import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { go } from '@src/utils/promise';
import AntdMessage from '@src/components/antd/message';

class EligibilityInquiryModalStore extends BaseModalStore {
  @observable checkPrizeUrl = '';
  @observable loading = false;
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /** 关闭弹窗 */
  onQrcodeModalClose = () => {
    this.onClickClose();
    if (this.closeCb) {
      this.closeCb();
    }
    this.onClose();
  };

  getQrcode = async () => {
    if (this.loading) return;
    this.loading = true;
    const [res, getUrlerr] = await go(this.$ztService.getCheckPrizeUrl());
    this.loading = false;
    if (getUrlerr) {
      AntdMessage.error(getUrlerr.message);
      return;
    }
    this.checkPrizeUrl = res.check_prize_url;
  };

  use(onClose) {
    super.use();
    if (onClose) {
      this.onClose = onClose;
    }
    useMount(() => this.getQrcode());
  }
}

export default EligibilityInquiryModalStore;
